import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { ProtectedRoute } from "@/components/layout/ProtectedRoute";

// Public
const LanguageSelection = lazy(() => import("./pages/LanguageSelection"));
const AuthScreen = lazy(() => import("./pages/AuthScreen"));
const LegalScreen = lazy(() => import("./pages/LegalScreen"));

// Protected
const HomeScreen = lazy(() => import("./pages/HomeScreen"));
const MarketScreen = lazy(() => import("./pages/MarketScreen"));
const ProductDetailScreen = lazy(() => import("./pages/ProductDetailScreen"));
const InvestScreen = lazy(() => import("./pages/InvestScreen"));
const BourseScreen = lazy(() => import("./pages/BourseScreen"));
const BourseDetailScreen = lazy(() => import("./pages/BourseDetailScreen"));
const FinancementScreen = lazy(() => import("./pages/FinancementScreen"));
const FarmerDetailScreen = lazy(() => import("./pages/FarmerDetailScreen"));
const AgentReportScreen = lazy(() => import("./pages/AgentReportScreen"));
const AcademiaScreen = lazy(() => import("./pages/AcademiaScreen"));
const CourseDetailScreen = lazy(() => import("./pages/CourseDetailScreen"));
const ModulePlayerScreen = lazy(() => import("./pages/ModulePlayerScreen"));
const CourseCompleteScreen = lazy(() => import("./pages/CourseCompleteScreen"));
const CertificatesScreen = lazy(() => import("./pages/CertificatesScreen"));
const ProfileScreen = lazy(() => import("./pages/ProfileScreen"));
const PortfolioScreen = lazy(() => import("./pages/PortfolioScreen"));
const NotificationsScreen = lazy(() => import("./pages/NotificationsScreen"));
const NotFound = lazy(() => import("./pages/NotFound"));
const ExploitationScreen = lazy(() => import("./pages/exploitation/ExploitationScreen"));
const KycScreen = lazy(() => import("./pages/KycScreen"));
const TransactionHistoryScreen = lazy(() => import("./pages/TransactionHistoryScreen"));
const MyBoursePositionsScreen = lazy(() => import("./pages/bourse/MyBoursePositionsScreen"));
const ListingOffersScreen = lazy(() => import("./pages/bourse/ListingOffersScreen"));
const HelpScreen = lazy(() => import("./pages/HelpScreen"));
const OnboardingScreen = lazy(() => import("./pages/OnboardingScreen"));
const TransformationScreen = lazy(() => import("./pages/TransformationScreen"));
const FarmAnalyticsScreen = lazy(() => import("./pages/FarmAnalyticsScreen"));
const MerchantTransactionsScreen = lazy(() => import("./pages/market/MerchantTransactions"));

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        {/* Index */}
        <Route path="/" element={<Navigate to="/language" replace />} />

        {/* Public */}
        <Route path="/language" element={<LanguageSelection />} />
        <Route path="/auth" element={<AuthScreen />} />
        <Route path="/mentions-legales" element={<LegalScreen />} />
        <Route path="/confidentialite" element={<LegalScreen />} />

        {/* Protected */}
        <Route path="/onboarding" element={<ProtectedRoute><OnboardingScreen /></ProtectedRoute>} />
        <Route path="/home" element={<ProtectedRoute><HomeScreen /></ProtectedRoute>} />
        <Route path="/market" element={<ProtectedRoute><MarketScreen /></ProtectedRoute>} />
        <Route path="/market/:productId" element={<ProtectedRoute><ProductDetailScreen /></ProtectedRoute>} />
        <Route path="/invest/:id" element={<ProtectedRoute><InvestScreen /></ProtectedRoute>} />
        <Route path="/bourse" element={<ProtectedRoute><BourseScreen /></ProtectedRoute>} />
        <Route path="/bourse/new" element={<Navigate to="/bourse" state={{ openCreate: true }} replace />} />
        <Route path="/bourse/:opportunityId" element={<ProtectedRoute><BourseDetailScreen /></ProtectedRoute>} />
        <Route path="/financement" element={<ProtectedRoute><FinancementScreen /></ProtectedRoute>} />
        <Route path="/financement/:farmerId" element={<ProtectedRoute><FarmerDetailScreen /></ProtectedRoute>} />
        <Route path="/report/new" element={<ProtectedRoute><AgentReportScreen /></ProtectedRoute>} />
        <Route path="/academia" element={<ProtectedRoute><AcademiaScreen /></ProtectedRoute>} />
        <Route path="/academia/certificates" element={<ProtectedRoute><CertificatesScreen /></ProtectedRoute>} />
        <Route path="/academia/:courseId" element={<ProtectedRoute><CourseDetailScreen /></ProtectedRoute>} />
        <Route path="/academia/:courseId/module/:moduleId" element={<ProtectedRoute><ModulePlayerScreen /></ProtectedRoute>} />
        <Route path="/academia/:courseId/complete" element={<ProtectedRoute><CourseCompleteScreen /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><ProfileScreen /></ProtectedRoute>} />
        <Route path="/portfolio" element={<ProtectedRoute><PortfolioScreen /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><NotificationsScreen /></ProtectedRoute>} />
        <Route path="/exploitation" element={<ProtectedRoute><ExploitationScreen /></ProtectedRoute>} />
        <Route path="/kyc" element={<ProtectedRoute><KycScreen /></ProtectedRoute>} />
        <Route path="/historique" element={<ProtectedRoute><TransactionHistoryScreen /></ProtectedRoute>} />
        <Route path="/bourse/mes-positions" element={<ProtectedRoute><MyBoursePositionsScreen /></ProtectedRoute>} />
        <Route path="/bourse/annonces/:listingId/offres" element={<ProtectedRoute><ListingOffersScreen /></ProtectedRoute>} />
        <Route path="/aide" element={<ProtectedRoute><HelpScreen /></ProtectedRoute>} />
        <Route path="/transformation" element={<TransformationScreen />} />
        <Route path="/farm-analytics" element={<ProtectedRoute><FarmAnalyticsScreen /></ProtectedRoute>} />
        <Route path="/mes-commandes" element={<ProtectedRoute><MerchantTransactionsScreen /></ProtectedRoute>} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
